import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../views/Login.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import Record from '../views/Record.vue'
import Device from '../views/Device.vue'
import Employee from '../views/Employee.vue'
import Group from '../views/Group.vue'
import Forbidden from '../views/Forbidden.vue'
import User from '../views/User.vue'
import Verify from '../views/Verify.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Profile from '../views/Profile.vue'
import Organization from '../views/Organization.vue'
import store from '../store'
import organization from '@/store/modules/organization'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { 
    path: '/', 
    redirect: { name: 'Record' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forget-password',
    name: 'ForgetPassword',
    component: ForgetPassword
  },
  {
    path: '/record',
    name: 'Record',
    component: Record,
    meta: { requiresLogin: true }
  },
  {
    path: '/device',
    name: 'Device',
    component: Device,
    meta: { requiresLogin: true }
  },
  {
    path: '/employee',
    name: 'Employee',
    component: Employee,
    meta: { requiresLogin: true }
  },
  {
    path: '/group',
    name: 'Group',
    component: Group,
    meta: { requiresLogin: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresLogin: true }
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: { requiresLogin: true, orgAdminOnly: true, adminOnly: true }
  },
  {
    path: '/organization',
    name: 'Organization',
    component: Organization,
    meta: { requiresLogin: true, adminOnly: true }
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Forbidden,
  },
  {
    path: '/verify/:code',
    name: 'Verify',
    component: Verify,
  },
  {
    path: '/reset/:code',
    name: 'Reset',
    component: ResetPassword,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async(to, from, next) => {
  store.commit('setCurrentPage', to.name)
  if (to.matched.some(record => record.meta.requiresLogin) && !store.state.isLogin) {
    try {
      await store.dispatch('init')
      if (!store.state.isLogin) {
        next({name: 'Login'})
      }
      else if ((to.matched.some(record => record.meta.adminOnly) && (store.state as any).userStore.role !== 'admin') 
            || (to.matched.some(record => record.meta.orgAdminOnly) && (store.state as any).userStore.role !== 'org_admin')) {
        next({name: 'Forbidden'})
      }
      else {
        next()
      } 
    }
    catch {
      next({name: 'Login'})
    }   
} else {
    next()
}
})

export default router
